import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Vue = () => {
  return (
    <StartInterviewLayout type="vue"/>
  )
}

export default Vue;